import { HeroStatisticsItemProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { C52HeroStatisticsItemProps } from './C52HeroStatisticsItem.types';

export function CreateHeroStatisticsItemModel(
  props?: C52HeroStatisticsItemProps
): HeroStatisticsItemProps {
  const { fields } = props || {};

  const { renderText } = useConditionalRendering();

  return {
    // topText should always render even if it's empty to preserve spacing.
    topText: renderText(fields?.TopText, { required: true }),
    // bottomText should always render even if it's empty to preserve spacing.
    bottomText: renderText(fields?.BottomText, { required: true }),
    statisticsNumber: renderText(fields?.StatisticsNumber, { required: true }),
    prefix: renderText(fields?.Prefix),
    suffix: renderText(fields?.Suffix),
    superscriptSuffix: renderText(fields?.SuperscriptSuffix),
  };
}
